export function isCompatibleEref(object1, object2) {

  const site1 = object1.site
  const site2 = object2.site

  const name1 = (object1.eref || object1.see)?.split('(')[0]
  const name2 = (object2.eref || object2.see)?.split('(')[0]

  if (name1 !== name2) return false
  if (!site1 || !site2) return true

  return site1 === site2
}

export function parseEref(eref) {
  const regex = /([^()]+)(?:\(([^)]+)\))?/
  const match = eref.match(regex)

  if (!match) {
    return { name, args: {}, value: eref }
  }

  const name = match[1].trim()
  const argsStr = match[2]
  const args = {}

  if (argsStr) {
    const argsPairs = argsStr.split(';')
    argsPairs.forEach(pair => {
      const [key, value] = pair.split('=').map(s => s.trim())
      args[key] = convertValue(value)
      args[key.toCamelCase()] = convertValue(value)
    })
  }

  return { name, args, value: eref }
}

function convertValue(value) {
  if (/^-?\d{1,8}$/.test(value)) {
    return parseInt(value, 10);
  } else if (/^-?\d{1,8}\.\d{1,8}$/.test(value)) {
    return parseFloat(value);
  } else if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return new Date(value);
  } else if (/^\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?$/.test(value)) {
    return value;
  } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?$/.test(value)) {
    return new Date(value);
  }
  return value;
}
